import { useEffect, useState } from "react";
import api from "../lib/api";
import { Compass, ArrowRight } from "lucide-react";

export default function NextActionCard({ leadId, refreshKey, onGo }) {
  const [na, setNa] = useState(null);
  useEffect(() => { api.get(`/leads/${leadId}/next-action`).then((r) => setNa(r.data)).catch(() => setNa(false)); }, [leadId, refreshKey]);
  if (na === false) return null;
  const s = na?.signals || {};
  return (
    <div className="border-l-4 border-[#E50914] border border-[#DFDAD0] bg-white p-5 flex flex-col md:flex-row md:items-center gap-4" data-testid="next-action-card" data-key={na?.key}>
      <div className="w-10 h-10 shrink-0 bg-[#E50914]/10 flex items-center justify-center"><Compass className="w-5 h-5 text-[#E50914]" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60">Recommended next action</div>
        <div className="text-lg font-semibold text-[#1C2530] leading-tight mt-0.5" data-testid="next-action-title">{na ? na.title : "Working it out…"}</div>
        {na && <div className="text-sm text-[#1C2530]/70 mt-1" data-testid="next-action-why">{na.why}</div>}
        {na && (
          <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 font-mono text-[10px] text-[#1C2530]/50" data-testid="next-action-signals">
            <span>{s.sent} sent</span><span>{s.drafts} drafts</span><span>{s.replies} replies</span><span>{s.meetings} meetings</span><span>{s.proposals} proposals</span><span>intent: {s.intent}</span>
          </div>
        )}
      </div>
      {na && (
        <button onClick={() => onGo(na.tab)} data-testid="next-action-cta"
          className="shrink-0 flex items-center gap-2 bg-[#E50914] text-white px-4 py-2.5 text-sm font-medium hover:bg-[#c40810]">
          {na.cta} <ArrowRight className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
